import { render } from "./tender_info.vue?vue&type=template&id=b046e37a&scoped=true"
import script from "./tender_info.vue?vue&type=script&lang=js"
export * from "./tender_info.vue?vue&type=script&lang=js"

import "./tender_info.vue?vue&type=style&index=0&id=b046e37a&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b046e37a"],['__file',"vue/js/components/contragent/tender/tabs/tender_info.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b046e37a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b046e37a', __exports__)) {
    console.log('reload')
    api.reload('b046e37a', __exports__)
  }
  
  module.hot.accept("./tender_info.vue?vue&type=template&id=b046e37a&scoped=true", () => {
    console.log('re-render')
    api.rerender('b046e37a', render)
  })

}


export default __exports__